module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-2.88647cb0.jpg";